import { MainLayoutComponent } from './main-layout/main-layout.component';
import { UnderConstructionComponent } from './under-construction/under-construction.component';

export const containers = [MainLayoutComponent, UnderConstructionComponent];

export * from './main-layout/main-layout.component';
export * from './under-construction/under-construction.component';
